import dayjs from 'dayjs';

export const buildDateInputFormatters = (format) => {
  return {
    formatDate: date => dayjs(date).format(format),
    parseDate: str => dayjs(str, format).toDate(),
  };
};
